
import React, { useState } from 'react';
import { Button } from '../../../components/base/Button';

export const WaitlistSection: React.FC = () => {
  const [formData, setFormData] = useState({
    vorname: '',
    nachname: '',
    email: '',
    telefon: '',
    unternehmen: '',
    branche: '',
    postleitzahl: '',
    mitarbeiteranzahl: '',
    herausforderungen: '',
    datenschutz: false
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value, type } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.datenschutz) {
      alert('Bitte stimmen Sie der Datenschutzerklärung zu.');
      return;
    }

    if (formData.herausforderungen.length > 500) {
      alert('Die Beschreibung der Herausforderungen darf maximal 500 Zeichen enthalten.');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formDataToSubmit = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSubmit.append(key, value.toString());
      });

      const response = await fetch('https://readdy.ai/api/form/d3p8ghevn82kpvfp3cpg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSubmit
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          vorname: '',
          nachname: '',
          email: '',
          telefon: '',
          unternehmen: '',
          branche: '',
          postleitzahl: '',
          mitarbeiteranzahl: '',
          herausforderungen: '',
          datenschutz: false
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="warteliste" className="py-20 bg-gradient-to-br from-blue-50 to-purple-50">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Warteliste beitreten
            </h2>
            <p className="text-xl text-gray-600 mb-8">
              Sichern Sie sich jetzt einen der letzten 40 Plätze für unsere Baufaktura Academy
            </p>
            
            <div className="bg-red-100 border border-red-300 rounded-lg p-6 mb-8 inline-block">
              <div className="flex items-center justify-center mb-2">
                <i className="ri-alarm-warning-line text-red-600 text-2xl mr-2"></i>
                <span className="text-lg font-semibold text-red-700">Nur noch 40 Plätze verfügbar!</span>
              </div>
              <p className="text-red-600">
                Academy Start: Januar 2026 - Begrenzte Teilnehmerzahl für maximale Qualität
              </p>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-8">
            <form id="warteliste-form" data-readdy-form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="vorname" className="block text-sm font-semibold text-gray-700 mb-2">
                    Vorname *
                  </label>
                  <input
                    type="text"
                    id="vorname"
                    name="vorname"
                    value={formData.vorname}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="Ihr Vorname"
                  />
                </div>
                
                <div>
                  <label htmlFor="nachname" className="block text-sm font-semibold text-gray-700 mb-2">
                    Nachname *
                  </label>
                  <input
                    type="text"
                    id="nachname"
                    name="nachname"
                    value={formData.nachname}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="Ihr Nachname"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                    E-Mail-Adresse *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="ihre.email@beispiel.de"
                  />
                </div>
                
                <div>
                  <label htmlFor="telefon" className="block text-sm font-semibold text-gray-700 mb-2">
                    Telefonnummer *
                  </label>
                  <input
                    type="tel"
                    id="telefon"
                    name="telefon"
                    value={formData.telefon}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="+49 123 456 789"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="unternehmen" className="block text-sm font-semibold text-gray-700 mb-2">
                  Unternehmen *
                </label>
                <input
                  type="text"
                  id="unternehmen"
                  name="unternehmen"
                  value={formData.unternehmen}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="Name Ihres Unternehmens"
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div>
                  <label htmlFor="branche" className="block text-sm font-semibold text-gray-700 mb-2">
                    Branche *
                  </label>
                  <div className="relative">
                    <select
                      id="branche"
                      name="branche"
                      value={formData.branche}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm appearance-none"
                    >
                      <option value="">Branche wählen</option>
                      <option value="Bau- und Hochbau">Bau- und Hochbau</option>
                      <option value="Kanal- und Tiefbau">Kanal- und Tiefbau</option>
                      <option value="GaLa Bau">GaLa Bau</option>
                      <option value="Elektro">Elektro</option>
                      <option value="SHK Bereich">SHK Bereich</option>
                      <option value="Dachdecker">Dachdecker</option>
                      <option value="Schreiner">Schreiner</option>
                      <option value="Photovoltaik">Photovoltaik</option>
                      <option value="Ausbau">Ausbau</option>
                      <option value="Maler & Stuckateur">Maler & Stuckateur</option>
                      <option value="Sonstiger Handwerk">Sonstiger Handwerk</option>
                    </select>
                    <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                  </div>
                </div>
                
                <div>
                  <label htmlFor="postleitzahl" className="block text-sm font-semibold text-gray-700 mb-2">
                    PLZ *
                  </label>
                  <input
                    type="text"
                    id="postleitzahl"
                    name="postleitzahl"
                    value={formData.postleitzahl}
                    onChange={handleInputChange}
                    required
                    maxLength={5}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="12345"
                  />
                </div>
                
                <div>
                  <label htmlFor="mitarbeiteranzahl" className="block text-sm font-semibold text-gray-700 mb-2">
                    Mitarbeiter *
                  </label>
                  <div className="relative">
                    <select
                      id="mitarbeiteranzahl"
                      name="mitarbeiteranzahl"
                      value={formData.mitarbeiteranzahl}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm appearance-none"
                    >
                      <option value="">Anzahl wählen</option>
                      <option value="1-5">1-5 Mitarbeiter</option>
                      <option value="6-20">6-20 Mitarbeiter</option>
                      <option value="21-50">21-50 Mitarbeiter</option>
                      <option value="51-100">51-100 Mitarbeiter</option>
                      <option value="100+">Über 100 Mitarbeiter</option>
                    </select>
                    <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                  </div>
                </div>
              </div>

              <div>
                <label htmlFor="herausforderungen" className="block text-sm font-semibold text-gray-700 mb-2">
                  Ihre größten Herausforderungen (max. 500 Zeichen)
                </label>
                <textarea
                  id="herausforderungen"
                  name="herausforderungen"
                  value={formData.herausforderungen}
                  onChange={handleInputChange}
                  maxLength={500}
                  rows={4}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm resize-none"
                  placeholder="Beschreiben Sie kurz Ihre wichtigsten Herausforderungen bei der Digitalisierung..."
                />
                <div className="text-right text-sm text-gray-500 mt-1">
                  {formData.herausforderungen.length}/500 Zeichen
                </div>
              </div>

              <div className="flex items-start">
                <input
                  type="checkbox"
                  id="datenschutz"
                  name="datenschutz"
                  checked={formData.datenschutz}
                  onChange={handleInputChange}
                  required
                  className="mt-1 mr-3 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
                <label htmlFor="datenschutz" className="text-sm text-gray-600">
                  Ich stimme der Verarbeitung meiner Daten gemäß der{' '}
                  <span className="text-blue-600 hover:underline cursor-pointer">Datenschutzerklärung</span> zu 
                  und bin damit einverstanden, dass mich die Baufaktura Academy bezüglich der Academy kontaktiert. *
                </label>
              </div>

              {submitStatus === 'success' && (
                <div className="bg-green-100 border border-green-300 rounded-lg p-4">
                  <div className="flex items-center">
                    <i className="ri-check-circle-line text-green-600 text-xl mr-2"></i>
                    <span className="text-green-700 font-semibold">
                      Vielen Dank! Ihre Anmeldung war erfolgreich. Wir melden uns in Kürze bei Ihnen.
                    </span>
                  </div>
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-100 border border-red-300 rounded-lg p-4">
                  <div className="flex items-center">
                    <i className="ri-error-warning-line text-red-600 text-xl mr-2"></i>
                    <span className="text-red-700 font-semibold">
                      Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.
                    </span>
                  </div>
                </div>
              )}

              <Button
                type="submit"
                variant="primary"
                size="lg"
                disabled={isSubmitting}
                className="w-full bg-blue-600 hover:bg-blue-700"
              >
                {isSubmitting ? (
                  <>
                    <i className="ri-loader-4-line animate-spin mr-2"></i>
                    Wird gesendet...
                  </>
                ) : (
                  <>
                    <i className="ri-send-plane-line mr-2"></i>
                    Jetzt Warteliste beitreten
                  </>
                )}
              </Button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};
